/* eslint-disable camelcase */
export enum EIconsBlog {
  poczta = '//images2.r.pl/r-pl/blog-nuxt/svg/poczta.svg',
  telefon = '//images2.r.pl/r-pl/blog-nuxt/svg/telefon.svg',
  mapa = '//images2.r.pl/r-pl/blog-nuxt/svg/mapa.svg',
  fala_mobile = '//images2.r.pl/r-pl/blog-nuxt/svg/fala-mobile.svg',
  fala_desktop = '//images2.r.pl/r-pl/blog-nuxt/svg/fala.svg',
  blog_menu = '//images2.r.pl/r-pl/blog-nuxt/svg/blog-menu.svg',
  lupka_mobile = '//images2.r.pl/r-pl/blog-nuxt/svg/lupka-mobile.svg',
  lupka_desktop = '//images2.r.pl/r-pl/blog-nuxt/svg/lupka.svg',
  cross = '//images2.r.pl/r-pl/blog-nuxt/svg/cross.svg',
  slonce = '//images2.r.pl/r-pl/blog-nuxt/svg/slonce.svg',
  samolot_prawy = '//images2.r.pl/r-pl/blog-nuxt/svg/samolot-prawy.svg',
}
